export enum CustomEventType {
  filesUpdated = 'filesUpdated'
}

type CustomEvent = {
  value: string;
  detail: string;
};

export type CustomEventProps = {
  detail: {
    [key: CustomEvent['detail']]: any;
  };
};

export const CustomEvents: Record<CustomEventType, CustomEvent> = {
  filesUpdated: {
    value: 'files-updated',
    detail: 'files'
  }
};
